import { JobDetailContainer } from '@/modules/job/presentation/containers';

type JobDetailScreenProps = {
	jobId: string
};

export const JobDetailScreen = ({ jobId }: JobDetailScreenProps) => {
	return <JobDetailContainer jobId={jobId} />;
};
